import React, {Fragment} from 'react';
import {Card, Diary} from 'components';
import {useNamedSelector} from 'helpers';

export function Group({ date, filter, ...props }) {
  const items = useNamedSelector('diary.byDate', { date, filter });
  const Wrapper = items.length > 1 ? Card.Group : Fragment;
  return (
    <Wrapper>
      { items.map(record =>
        <Diary.Card key={record.id} id={record.id} inGroup={items.length > 1} {...props} />
      ) }
    </Wrapper>
  );
}
